declare global {
	interface Window {
		userpilotSettings?: { token: string };
	}
}

export function loadUserpilotSdk(token: string): Promise<void> {
	window.userpilotSettings = { token };

	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = 'https://js.userpilot.io/sdk/latest.js';
		script.onload = () => resolve();
		script.onerror = () => reject(new Error('Userpilot SDK failed to load'));
		document.head.appendChild(script);
	});
}
